// Phase 11a — PayoutLine read shape per 11-3 schema sketch.
// Mirrors InvoiceLineResponseSchema field-for-field except no HST
// columns (HST is per-payout-header per 11a-5).
import { z } from 'zod';
import { PayoutLineTypeSchema } from './enums.schema.js';
export const PayoutLineResponseSchema = z.object({
    id: z.string().uuid(),
    payoutId: z.string().uuid(),
    shiftId: z.string().uuid().nullable(),
    lineType: PayoutLineTypeSchema,
    description: z.string(),
    quantityHours: z.string(), // Prisma Decimal → string for transport safety
    unitPayRate: z.string(),
    subtotalCents: z.number().int().nonnegative(),
    /** FK to CaregiverGuaranteePolicy (NOT 10b's CancellationPolicy).
     *  Set on CANCELLATION_PAY lines only. */
    appliedPolicyId: z.string().uuid().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=payout-line.schema.js.map